import React, { FC, useState, useEffect, ReactNode } from "react";
import injectSheet from "react-jss";
import { Row, Column } from "simple-flexbox";

import styleSheet from "./styles";

interface Props {
  classes: any;
  isOpen: boolean; //Determins if the sidebar is open and class composition for elements
}

const sideBarContent: FC<Props> = ({ classes, children, isOpen }) => (
  <Row className={classes.wrapper} vertical="stretch">
    <Column
      className={`
      ${classes.sideBar} 
      ${isOpen ? classes.sideBarIsOpen : classes.sideBarIsClosed}`}
    >
      <Row>
        <Column style={{ width: "100%" }}>{children}</Column>
      </Row>
    </Column>
  </Row>
);

export const SideBarContent = injectSheet(styleSheet)(sideBarContent);
